import React from "react";
import { LASTLOGINDETAILS } from "../../App.config";
import * as utilities from "../../utilities/utils";

const LastLoginDetailComponent = (props) => {
  return (
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            {props.context.t("Setting.Last.Login.Details.text")}
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => props.closeRemoveModal()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <span>
            {Array.isArray(props.lastLoginDetails) &&
            props.lastLoginDetails.length
              ? props.lastLoginDetails.map((detail) => (
                  <ul>
                    <li className={props.lastLoginDetails[0].createdOnDate == detail.createdOnDate ? "current-login" : "last-login"} key={detail.createdOnDate}>
                      <span className="last-login-first-span">Canada</span>
                      <span>
                        {utilities.formatDate(
                          detail.createdOnDate,
                          "MMM DD YYYY, h:mm:ss a"
                        )}
                      </span>
                    </li>
                  </ul>
                ))
              : null}
          </span>
        </div>
        {/* <div className="modal-footer">  
        </div> */}
      </div>
    </div>
  );
};
export default LastLoginDetailComponent;
